<template>
  <page-view>
    <div class="user_wrapper">
      <a-tabs @change="changeQueryType" :activeKey="activeKey">
        <a-tab-pane key="0" :tab="`全部（${totalNum}）`"></a-tab-pane>
        <a-tab-pane key="true" tab="付费"></a-tab-pane>
        <a-tab-pane key="false" tab="普通用户"></a-tab-pane>
        <a-input
          slot="tabBarExtraContent"
          placeholder="距离最后付费时间天数"
          style="width:180px;margin-right:12px"
          v-model.trim="lastPayDay"
        />
        <a-input
          slot="tabBarExtraContent"
          placeholder="用户ID"
          class="query_input"
          v-model.trim="queryParam.uid"
        />
        <a-input
          slot="tabBarExtraContent"
          placeholder="用户名"
          class="query_input"
          v-model.trim="queryParam.username"
        />
        <a-button
          slot="tabBarExtraContent"
          type="primary"
          class="query_btn"
          @click="
            () => {
              $refs.table.refresh(false);
            }
          "
          >查询</a-button
        >
        <a-button slot="tabBarExtraContent" @click="resetQuery">重置</a-button>
      </a-tabs>
      <s-table
        style="margin:0 24px"
        ref="table"
        rowKey="id"
        :columns="columns"
        :data="dataSource"
      >
        <span slot="serial" slot-scope="text, record, index">{{
          index + 1
        }}</span>
        <template slot="uid" slot-scope="text, record">
          <a-tooltip placement="right" overlayClassName="tooltip_custom">
            <template slot="title">
              <span>点击复制</span>
            </template>
            <span
              class="uid_fat"
              @mouseover="handleMouseover(record)"
              @mouseout="handleMouseout(record)"
              @click="copyInfo(record.uid)"
            >
              {{ text.substring(0, 8) + "……" + text.substring(24) }}
              <span class="uid_child" v-show="record.showid">{{ text }}</span>
            </span>
            <input type="text" class="input2" />
          </a-tooltip>
        </template>
        <template slot="pay" slot-scope="text">
          <span v-if="text">是</span>
          <span v-else>否</span>
        </template>
        <template slot="hasOemRole" slot-scope="text, record">
          <span :style="{ color: text ? 'green' : undefined }">
            {{ text ? "已开通" : "-" }}
          </span>
        </template>
        <template slot="operation" slot-scope="text, record">
          <!-- <a style="margin-right: 12px" @click="openPriceSet(record)"
            >价格设置</a
          > -->
          <a @click="getUserByUid(record.uid)">查看联系方式</a>
          <a
            v-if="!record.hasOemRole"
            style="margin-left: 12px"
            @click="openOemSet(record)"
          >
            开通分站
          </a>
          <a style="margin-left: 12px" @click="openTiaoJia(record)">调价</a>
        </template>
      </s-table>
      <a-modal
        title="查看联系方式"
        :width="560"
        :visible="user.show"
        @ok="() => (user.show = false)"
        @cancel="() => (user.show = false)"
      >
        <p>用户ID：{{ user.detail.id }}</p>
        <p>用户昵称：{{ user.detail.username }}</p>
        <p>用户手机号：{{ user.detail.mobile }}</p>
      </a-modal>
      <a-modal
        title="价格设置"
        :width="560"
        :visible="priceSet.show"
        :confirm-loading="priceSet.confirmLoading"
        @ok="savePriceSet"
        @cancel="() => (priceSet.show = false)"
      >
        <a-form layout="horizontal">
          <a-form-item
            label="商品价"
            :labelCol="{ span: 5 }"
            :wrapperCol="{ span: 16 }"
          >
            <a-space>
              <a-input-number
                v-model="priceSet.detail.price"
                style="width: 300px"
              />
              <a-tooltip title="指定快递/商品价多少，不能超过分站本身的加价">
                <a-icon type="bulb" theme="twoTone" />
              </a-tooltip>
            </a-space>
          </a-form-item>
          <a-form-item
            label="快递价"
            :labelCol="{ span: 5 }"
            :wrapperCol="{ span: 16 }"
          >
            <a-space>
              <a-input-number
                v-model="priceSet.detail.deliverPrice"
                style="width: 300px"
              />
              <a-tooltip title="指定快递/商品价多少，不能超过分站本身的加价">
                <a-icon type="bulb" theme="twoTone" />
              </a-tooltip>
            </a-space>
          </a-form-item>
        </a-form>
      </a-modal>
      <a-modal
        title="开通分站权限"
        :width="1260"
        :visible="oemEdit.show"
        destroyOnClose
        :confirm-loading="oemEdit.confirmLoading"
        @cancel="() => (oemEdit.show = false)"
      >
        <OpenOemAuth ref="oemAuth" />
        <template #footer>
          <a-space>
            <a-button @click="oemEdit.show = false">取消</a-button>
            <a-popconfirm
              title="确认开通分站？开通后无法取消！"
              cancelText="再考虑下"
              @confirm="openOemAuth"
            >
              <a-button type="primary">提交</a-button>
            </a-popconfirm>
          </a-space>
        </template>
      </a-modal>
      <a-modal
        title="调价"
        :width="1300"
        :visible="tiaojia.show"
        destroyOnClose
        @ok="() => (tiaojia.show = false)"
        @cancel="() => (tiaojia.show = false)"
      >
        <BatchPrice :uid="tiaojia.uid"/>
      </a-modal>
    </div>
  </page-view>
</template>

<script>
import BatchPrice from './batchPrice.vue'
import { STable } from "@/components";
import { sipUserByUid, accountList, accountGet, oemInsert } from "@api";
import { formatDate } from "@/utils/util";
import { PageView } from "@/layouts";
import OpenOemAuth from "./openOemAuth.vue";
export default {
  data() {
    return {
      totalNum: 0,
      activeKey: "0",
      account: {},
      user: { detail: {}, show: false },
      tiaojia: { show: false, uid: undefined },
      priceSet: { detail: {}, show: false, confirmLoading: false },
      queryParam: {},
      lastPayDay: "",
      columns: [
        {
          title: "序号",
          scopedSlots: { customRender: "serial" }
        },
        {
          title: "用户ID",
          dataIndex: "uid",
          scopedSlots: { customRender: "uid" }
        },
        {
          title: "手机号",
          dataIndex: "mobile"
        },
        {
          title: "用户名",
          dataIndex: "username"
        },
        {
          title: "推广码",
          dataIndex: "code"
        },
        {
          title: "是否付费用户",
          dataIndex: "pay",
          scopedSlots: { customRender: "pay" }
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          customRender: formatDate
        },

        {
          title: "最后付费时间",
          dataIndex: "lastPayTime",
          customRender: formatDate
        },
        {
          title: "修改时间",
          dataIndex: "updateTime",
          customRender: formatDate
        },
        {
          title: "分站权限",
          dataIndex: "hasOemRole",
          scopedSlots: { customRender: "hasOemRole" }
        },
        {
          title: "操作",
          dataIndex: "id",
          scopedSlots: { customRender: "operation" }
        }
      ],
      dataSource: parameter => {
        return accountList(
          "oem",
          Object.assign(parameter, this.queryParam)
        ).then(result => {
          //用户总数
          this.totalNum = result.data.page.total;

          let filterData = JSON.parse(JSON.stringify(result.data));
          // 如果有最后付费天数筛选
          if (this.lastPayDay) {
            filterData.list = filterData.list.filter(item => {
              return (
                (new Date().getTime() - item.lastPayTime) / 86400000 <
                Number(this.lastPayDay)
              );
            });
          }
          //类型筛选
          if (this.activeKey == "0") {
            filterData.list.forEach(item => (item.showid = false));
            return filterData;
          } else {
            const data2 = JSON.parse(JSON.stringify(filterData));
            data2.list = data2.list.filter(
              item => String(item.pay) == this.activeKey
            );
            data2.list.forEach(item => (item.showid = false));
            return data2;
          }
        });
      },
      oemEdit: { show: false, confirmLoading: false, detail: {} }
    };
  },
  components: {
    STable,
    PageView,
    OpenOemAuth,
    BatchPrice
  },
  mounted() {
    accountGet().then(res => {
      this.account = res.data;
    });
  },
  methods: {
    openTiaoJia(record) {
      this.tiaojia.show = true;
      this.tiaojia.uid = record.id;
    },
    openOemSet(record) {
      this.oemEdit = {
        show: true,
        confirmLoading: false,
        detail: JSON.parse(JSON.stringify(record))
      };
    },
    async openOemAuth() {
      const editData = this.$refs.oemAuth.commit();
      const data = { ...editData, type: 3, uid: this.oemEdit.detail.uid };
      console.log("[data] ---> ", data);
      if (!editData) return;
      const res = await oemInsert(data);
      if (res.success) {
        this.$message.success("开通成功！");
        this.oemEdit.show = false;
        this.$refs.table.refresh(false);
      } else {
        this.$message.error(res.msg || "开通失败！");
      }
    },
    openPriceSet(record) {
      this.priceSet.detail = JSON.parse(JSON.stringify(record));
      this.priceSet.show = true;
    },
    async savePriceSet() {
      this.priceSet.confirmLoading = true;
      await new Promise(resolve => setTimeout(() => resolve(1), 2000));
      // TODO 待接接口
      this.priceSet.confirmLoading = false;
      this.priceSet.show = false;
      this.$refs.table.refresh(false);
    },
    handleMouseover(record) {
      record.showid = true;
    },
    handleMouseout(record) {
      record.showid = false;
    },
    getUserByUid(uid) {
      sipUserByUid(uid).then(res => {
        this.user.detail = res;
        this.user.show = true;
      });
    },

    //tab切换
    changeQueryType(key) {
      this.activeKey = key;
      this.$refs.table.refresh(false);
    },
    //重置
    resetQuery() {
      this.lastPayDay = "";
      this.activeKey = "0";
      this.queryParam = {};
      this.$refs.table.refresh(false);
    }
  }
};
</script>

<style lang="less" scoped>
.user_wrapper {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 20px rgba(15, 41, 131, 0.1);
  border-radius: 4px;
  padding-bottom: 24px;
  font-family: PingFang SC;
}
.uid_fat {
  position: relative;
  cursor: pointer;
  .uid_child {
    position: absolute;
    bottom: -40px;
    left: 32px;
    padding: 4px 8px;
    background-color: #f0f0f0;
    border-radius: 2px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
  }
}

.query_input {
  width: 240px;
  height: 32px;
  margin-right: 12px;
}
.query_btn {
  margin-right: 12px;
}
//tab栏
/deep/ .ant-tabs-nav .ant-tabs-tab {
  margin: 0 16px 0 16px;
  padding: 16px 12px;
}
/deep/ .ant-tabs {
  margin-right: 24px;
}
/deep/ .ant-tabs-extra-content {
  line-height: 53px;
}
</style>
